import React, { useContext, useEffect, useState } from 'react';
import cn from 'classnames';
import Popup from '../Popup/Popup';
import { getOpenTier } from '../../summit-program/summit';
import { UserContext } from '../WithUserState/WithUserState';
import styles from './BuyModal.css';
import crossIcon from '../../images/cross-icon.svg';
import checkmark from '../../images/checkmark-circle.svg';
import errorMessage from '../../images/error-message.svg';
import { containsAClosedFund, containsOpenFund } from './util';
import { genKey } from '../../utils/addKey';
import { dispatchOverlayLoad } from '../../utils/modal-utils';
import SummitLink from '../SummitMessage/SummitLink';

const BuyModal = ({
    fundName,
    loggedIn,
    open,
    fundIsOpen,
    onClose,
    ticker,
    funds,
    userStateLoaded,
    multiBuy,
    openToNewInvestors
}) => {
    const [openActTypeModal, setOpenActTypeModal] = useState(false);
    const [buyTickers, setTickers] = useState([]);
    const { summitTier } = useContext(UserContext) || {};
    const isOpenTier = getOpenTier(summitTier);
    const showSummit =
        openToNewInvestors === undefined
            ? containsAClosedFund(funds)
            : !openToNewInvestors;

    useEffect(
        () => {
            // Send analytics the overlay state
            if (!multiBuy) {
                const overlay = openActTypeModal
                    ? 'Choose Account Type'
                    : `Fund Selected - ${ticker}`;
                dispatchOverlayLoad(overlay);
            }
        },
        [openActTypeModal]
    );

    useEffect(() => {
        if (multiBuy) {
            const openFunds = funds.filter(
                (f) => f.openToNewInvestors || isOpenTier
            );
            setTickers(openFunds.map((f) => f.ticker));
        } else setTickers(ticker);
    }, []);

    return (
        <React.Fragment>
            {/* INTERSTITIAL MODAL */}
            <Popup
                open={open}
                onClose={onClose}
                closeOnDocumentClick
                closeOnEscape
                contentStyle={{ width: 360 }}
            >
                {open &&
                    !openActTypeModal && (
                        <div className="modal">
                            <button
                                className="close-btn"
                                onClick={() => onClose()}
                                type="button"
                            >
                                <img alt="Close" src={crossIcon} />
                            </button>

                            <div className="centered-content">
                                {multiBuy ? (
                                    <div className="funds-modal-title">
                                        Selected Funds
                                    </div>
                                ) : (
                                    <img
                                        className="check-mark"
                                        alt="Check Mark"
                                        src={
                                            fundIsOpen || isOpenTier
                                                ? checkmark
                                                : errorMessage
                                        }
                                    />
                                )}

                                <div className="fund-info">
                                    {multiBuy ? (
                                        funds.map((fund) => (
                                            <div
                                                key={`fund-${
                                                    fund.ticker
                                                }-${genKey()}`}
                                                className={cn('fund-name', {
                                                    closed: !(
                                                        fund.openToNewInvestors ||
                                                        isOpenTier
                                                    )
                                                })}
                                            >
                                                {fund.openToNewInvestors ||
                                                isOpenTier
                                                    ? fund.name
                                                    : `(CLOSED) ${
                                                          fund.name
                                                      }`}{' '}
                                                <strong>{fund.ticker}</strong>
                                            </div>
                                        ))
                                    ) : (
                                        <div
                                            className={cn('fund-name', {
                                                closed: !(
                                                    !showSummit || isOpenTier
                                                )
                                            })}
                                        >
                                            {!showSummit || isOpenTier
                                                ? fundName
                                                : `(CLOSED) ${fundName}`}{' '}
                                            <strong>{ticker}</strong>{' '}
                                            {fundIsOpen && 'selected'}
                                        </div>
                                    )}
                                </div>

                                <div className="buttons">
                                    {showSummit &&
                                        (!isOpenTier ? (
                                            <div className="summit-notice">
                                                One way to get preferred access
                                                to closed funds is by achieving
                                                an appropriate status in the
                                                Summit Program.{' '}
                                                <SummitLink
                                                    loggedIn={loggedIn}
                                                    pathname={
                                                        window.location.pathname
                                                    }
                                                />
                                            </div>
                                        ) : (
                                            <div className="summit-notice unlocked">
                                                You have preferred access to{' '}
                                                {multiBuy
                                                    ? 'closed funds'
                                                    : 'this closed fund'}{' '}
                                                because of your Summit Program
                                                status.
                                            </div>
                                        ))}
                                    {(containsOpenFund(funds) ||
                                        fundIsOpen ||
                                        isOpenTier) && (
                                        <React.Fragment>
                                            <button
                                                className="confirm-fund proceed"
                                                id={
                                                    ticker
                                                        ? `confirm-${ticker}`
                                                        : 'confirm-buy'
                                                }
                                                onClick={() =>
                                                    setOpenActTypeModal(true)
                                                }
                                                disabled={
                                                    (multiBuy
                                                        ? !containsOpenFund(
                                                              funds
                                                          )
                                                        : !fundIsOpen) &&
                                                    !isOpenTier
                                                }
                                                type="button"
                                            >
                                                <React.Fragment>
                                                    Add Fund{buyTickers.length >
                                                        1 && 's'}{' '}
                                                    To{' '}
                                                    {userStateLoaded && loggedIn
                                                        ? 'a New'
                                                        : 'An'}{' '}
                                                    Account
                                                </React.Fragment>
                                            </button>
                                        </React.Fragment>
                                    )}
                                    {userStateLoaded &&
                                        (containsOpenFund(funds) ||
                                            fundIsOpen ||
                                            isOpenTier) && (
                                            <div className="login proceed">
                                                Or{' '}
                                                {!loggedIn && (
                                                    <React.Fragment>
                                                        <a
                                                            href={`/usis/login/?pdurl=/v0/ciam-public/me?sdurl=https://${
                                                                window.location
                                                                    .host
                                                            }/usis/transactions/buy`}
                                                        >
                                                            <u className="login-underline">
                                                                log in
                                                            </u>{' '}
                                                        </a>
                                                        to{' '}
                                                    </React.Fragment>
                                                )}
                                                add this fund to an{' '}
                                                {loggedIn ? (
                                                    <a
                                                        href={`/usis/login/?pdurl=/v0/ciam-public/me?sdurl=https://${
                                                            window.location.host
                                                        }/usis/transactions/buy`}
                                                    >
                                                        <u className="login-underline">
                                                            <br />
                                                            existing account
                                                        </u>
                                                    </a>
                                                ) : (
                                                    <span>
                                                        existing account
                                                    </span>
                                                )}
                                            </div>
                                        )}
                                </div>
                            </div>
                        </div>
                    )}
                {/* ACCOUNT TYPE MODAL */}
                {openActTypeModal && (
                    <div className="modal2">
                        <button
                            className="close-btn"
                            onClick={() => onClose()}
                            type="button"
                        >
                            <img
                                className="close-btn-img"
                                alt="Close"
                                src={crossIcon}
                            />
                        </button>
                        <div className="centered-content-2">
                            <div className="title2">
                                Choose an account you&apos;d like to open
                            </div>

                            <hr />

                            <div className="category">
                                <div className="category-title">
                                    RETIREMENT &amp; IRAS
                                </div>
                                <div className="account-types">
                                    <a
                                        href={`/personal-investing/tools/nasu/mutual-fund/retirement/rollover?selectedFund=${buyTickers}`}
                                    >
                                        Rollover IRA
                                    </a>
                                    <a
                                        href={`/personal-investing/tools/nasu/mutual-fund/retirement/contributory/roth?selectedFund=${buyTickers}`}
                                    >
                                        Roth IRA
                                    </a>
                                    <a
                                        href={`/personal-investing/tools/nasu/mutual-fund/retirement/contributory/traditional?selectedFund=${buyTickers}`}
                                    >
                                        Traditional IRA
                                    </a>
                                </div>
                            </div>

                            <div className="category">
                                <div className="category-title">
                                    GENERAL INVESTING
                                </div>
                                <div className="account-types">
                                    <a
                                        href={`/personal-investing/tools/nasu/mutual-fund/general-investing/individual?selectedFund=${buyTickers}`}
                                    >
                                        Individual
                                    </a>
                                    <a
                                        href={`/personal-investing/tools/nasu/mutual-fund/general-investing/joint?selectedFund=${buyTickers}`}
                                    >
                                        Joint
                                    </a>
                                    <a
                                        href={`/personal-investing/tools/nasu/mutual-fund/general-investing/ugma-utma?selectedFund=${buyTickers}`}
                                    >
                                        Custodial (UGMA/UTMA)
                                    </a>
                                    <a
                                        href={`/personal-investing/tools/nasu/mutual-fund/general-investing/trust?selectedFund=${buyTickers}`}
                                    >
                                        Trust
                                    </a>
                                </div>
                            </div>
                        </div>

                        <hr />

                        <div className="see-all">
                            Don&apos;t see your account?&nbsp;
                            <a href="/personal-investing/account-finder/all-t-rowe-price-accounts.html">
                                See All
                            </a>
                        </div>
                    </div>
                )}
            </Popup>
            <style jsx>{styles}</style>
        </React.Fragment>
    );
};

export default BuyModal;
